module.exports = __webpack_public_path__ + "static/img/global_more_arrow@3x.9f917b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/global_more_arrow@3x.png
// module id = MkyX
// module chunks = 1